import { Unit } from "@xanadu/model";
import { DataService } from "../../service/data/data.service";
import { DataCache } from "./data.cache";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class UnitCache extends DataCache<Unit> {

    constructor(
        dataService: DataService
    ) {
        super(Unit, dataService);
    }
}
